import React, {  } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  Typography
} from '@material-ui/core';
import { importTypeStateSelector } from 'store/selectors';
import classNames from 'classnames';

import DataGrid, {
  Column,
  Pager,
  Paging,
  Sorting,
  Scrolling,
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { Constants } from 'utilities/constants';
import { PostAcquisitionImportFieldSettings } from 'components/admin/postAcquisitionImport/PostAcquisitionImportFieldSettings';

const PostAcquisitionImportGrid = React.forwardRef(({ classes, importRows }, gridRef) => {

  const maxCountExceeded = importRows?.length > Constants.ImportMaxCount.BACKFILL;

  function getHeaderCell(el, headerStyle) {
    return (
      <div>
        <span>{el.data.column.caption}</span>
        {headerStyle.required &&
          <span className={classes.requiredField}>*</span>
        }
      </div>
    )
  }

  const onToolbarPreparing = e => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        template: 'totalCount'
      },
      {
        location: 'before',
        template: 'columnKey'
      },
    );
  }

  const toolbarItemRender = (e) => {
    switch (e.template) {
      case 'totalCount':
        return totalCountTemplate();
      case 'columnKey':
        return columnKeyTemplate();
      default:
        return;
    }
  }


  const totalCountTemplate = () => {
    return (<div className={classNames(classes.informer, maxCountExceeded && classes.errorInformer)}>
      <span className={classes.countLabel}>{importRows?.length ?? 0}</span>
      <span className={classes.totalCountText}>Total Count</span>
    </div>)
  }

  const columnKeyTemplate = () => {
    return (<div style={{ padding: 4 }}>
      <Typography variant='body2'><span style={{ color: 'red' }}>*</span> Required field</Typography>
    </div>)
  }

  const gridId = 'postAcqImport'

  return (
    <div className={classes.gridContainer}>
      <DataGrid
        id={gridId}
        ref={gridRef}
        dataSource={importRows} // Create array of new rows, else deleting rows/editing cells will mutate the state
        keyExpr='referenceId'
        persistState
        allowColumnResizing={true}
        height={'calc(100vh - 353px)'}
        columnResizingMode='widget'
        showBorders={true}
        hoverStateEnabled={true}
        showRowLines={true}
        showColumnLines={true}
        onToolbarPreparing={onToolbarPreparing}
        focusedRowEnabled={false}
      >
        <Template name='totalCount' render={toolbarItemRender} />
        <Template name='columnKey' render={toolbarItemRender} />
        <Sorting mode='none' />
        <Scrolling rowRenderingMode='virtual' columnRenderingMode='virtual' />
        <Paging
          defaultPageSize={100}
          enabled={false}
        />
        <Pager showInfo={true} />
        {PostAcquisitionImportFieldSettings.map(({ field, width, type, format, required, displayName, tooltip }) => {
          const headerStyle = {
            required
          }
          return (
            <Column
              key={field}
              dataField={field}
              caption={displayName}
              tooltip={tooltip}
              allowColumnResizing={true}
              minWidth={width}
              dataType={type === 'date' ? 'string' : type}
              format={format}
              allowExporting={true}
              headerCellComponent={headerStyle ? (el) => getHeaderCell(el, headerStyle) : undefined}
            >
            </Column>
          )
        })}
      </DataGrid>
    </div>
  )
})

const styles = theme => ({
  gridContainer: {
    padding: '5px 8px 8px'
  },
  requiredField: {
    color: 'red'
  },
  autofillField: {
    fontWeight: '800'
  },
  informer: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    width: '130px',
    background: '#80a4c7',
    color: '#fff',
    textAlign: 'center'
  },
  exclusionInformer: {
    background: '#67c12e',
  },
  errorInformer: {
    background: '#d32f2f'
  },
  countLabel: {
    fontSize: '18px',
    paddingTop: '5px',
    margin: '0'
  },
  totalCountText: {
    paddingBottom: '5px',
  },
});

const mapStateToProps = state => {
  const opportunitiesState = importTypeStateSelector(state, Constants.ImportType.BACKFILL);
  return {
    importRows: opportunitiesState.importRows,
  }
}

const mapDispatchToProps = dispatch => {

};

export default compose(withStyles(styles), connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
))(PostAcquisitionImportGrid);